import { differenceInDays } from 'date-fns';
export const showNewAppMessage = appHeaderDetails => {
  const {
    createdAt,
    distribution,
    ratings
  } = appHeaderDetails;
  const {
    installationCount,
    downloadCount,
    isPreinstalledInAnyHosting,
    isPreinstalled
  } = distribution || {};
  const isNewApp = !!createdAt && differenceInDays(new Date(), createdAt) <= 30;
  return isNewApp && !isPreinstalled && !isPreinstalledInAnyHosting && !downloadCount && !installationCount && !ratings.numRatings;
};